import isEmpty from 'lodash/isEmpty'
import { FC, isValidElement } from 'react'

import { StepBar } from './components/StepBar'
import { StepHeader } from './components/StepHeader'
import type { StepHeaderProps } from './components/StepHeader'
import * as Styled from './Stepper.styled'

interface StepperProps extends StepHeaderProps {
  step: number
}

export const Stepper: FC<StepperProps> = ({
  step,
  title,
  description,
  onBackClick,
  hideBackButton,
}) => (
  <Styled.Container hasText={!((isEmpty(title) || isValidElement(title)) && isEmpty(description))}>
    <StepBar step={step} />
    <StepHeader
      title={title}
      description={description}
      onBackClick={onBackClick}
      hideBackButton={hideBackButton}
    />
  </Styled.Container>
)
